import { map, Observable, of, switchMap } from 'rxjs';
import {
  StorePreviewVideoUpload,
  VideoUploadType,
} from '../../models/ClientModels';
import { firestore } from '../firebase/firebaseAccess';
import { collectionDataWithId } from '../firebase/rxfireExtensions';
import { useObservable } from '../hooks/useObservable';

const query$ = (sellerId: string | undefined) => {
  return of(sellerId).pipe(
    switchMap(
      (id): Observable<StorePreviewVideoUpload[]> =>
        id
          ? collectionDataWithId(
              firestore()
                .collection('videoUploads' as any)
                .where('userId', '==', sellerId)
                .where('type', '==', VideoUploadType.storePreview)
                .where('status', 'in', ['none', 'processing'])
                //.orderBy('createdAt', 'desc')
                .limit(1),
            )
          : of([]),
    ),
    map(res => (res.length ? res[0] : undefined)),
  );
};

export const usePendingStoreReelUpload = (sellerId: string) => {
  return useObservable(
    () => query$(sellerId),
    `seller:${sellerId}:pending-store-reel-upload`,
  );
};
